(function($) {

	let $form = $("form#checkout-form")

	// Update cart

	function update_cart(){
        const $register_checkbox = $form.find("input[name='register']")

		let url = ghostpress_params.ajax_url + "&action=update_cart",
			data = {
				shipping_country: $form.find("select[name='shipping_country']").val(),
                billing_country: $form.find("select[name='billing_country']").val(),
				shipping_method_id: $form.find("input[name='shipping_method']:checked").val(),
				payment_method_id: $form.find("input[name='payment_method']:checked").val(),
				register: $register_checkbox.is(":checked") && !$register_checkbox.is(":disabled") ? 1 : 0,
			}

		if($form.find("input[name='show_company_info']").is(":checked")){
			data.billing_vat_number = $form.find("input[name='billing_dic']").val()
		}else{
			data.billing_vat_number = ""
        }
		if(!$form.find("input[name='ship_to_different_address']").is(":checked")){
            data.shipping_country = data.billing_country;
		}

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				// jQuery( document ).trigger('cart_updated')
				// jQuery(document).trigger('open_modal', ['cart'])
				// jQuery( document ).trigger( 'gp_update_checkout' )
			})

	}

	$form.find("select[name='shipping_country']").change(update_cart)
	$form.find("select[name='billing_country']").change(update_cart)
	$form.find("input[name='show_company_info']").change(update_cart)
	$form.find("input[name='billing_dic']").change(update_cart)
	$form.find("input[name='ship_to_different_address']").change(update_cart)

    $form.find("input[name='register']").change(function (){
        // Hide and uncheck the newsletter opt-out checkbox when the register user checkbox is checked
        if ($(this).is(':checked')) {
            $('input[type=checkbox][name=newsletter_do_not_subscribe]').prop('disabled', true)
            $("div.terms_newsletter_do_not_subscribe").slideUp(250)
        }
        else {
            $('input[type=checkbox][name=newsletter_do_not_subscribe]').prop('disabled', false)
            $("div.terms_newsletter_do_not_subscribe").slideDown(250)
        }

        update_cart()
    })

	// Init again fields from AJAX fragments
	$(document).gp_ready(function(){
		$form.find("input[name='shipping_method']").change(update_cart)
		$form.find("input[name='payment_method']").change(update_cart)
	})

	// Complete order
	function complete_order(e){

		e.preventDefault()

		let url = ghostpress_params.ajax_url + "&action=complete_order",
			data = $(this).serializeArray()

		// Clear old general notices before sending request
		let $notices_list = $(".notices.general-notices, .notices").first();
		if ($notices_list.length) {
			$notices_list.empty().hide();
		}

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
		.done((response, textStatus, jqXHR) => {

			let success = response.success
            
			if(success){

			}else{
                
                let has_inline_errors = false;
                let orphan_errors = [];

                function getFieldRow(field_id) {
                    // 1. Direct id: #billing_first_name_field
                    let $row = $('#' + field_id + '_field');
                    if ($row.length && $row.is(':visible')) {
                        return $row;
                    }

                    // 2. By input / select / textarea element in the form
                    let $input = $form.find(`[name="${field_id}"], [name="billing_${field_id}"], [name="shipping_${field_id}"]`).filter(':visible');
                    if ($input.length) {
                        let $closest_row = $input.closest('.form-row');
                        if ($closest_row.length && $closest_row.is(':visible')) {
                            return $closest_row;
                        }
                    }

                    return null;
                }

                // Handle inline field errors if returned by backend.
                // Backend sends `invalid_fields` as a map: { field_id: 'error text', ... }
                if (typeof response.data !== 'undefined' && typeof response.data.invalid_fields !== 'undefined') {
                    let invalid_fields = response.data.invalid_fields || {};
                    let invalid_field_ids = Object.keys(invalid_fields);

                    // 1. Remove errors from fields that are NO LONGER invalid
                    $form.find('.form-row.woocommerce-invalid').each(function() {
                        let $row = $(this);
                        let row_id = $row.attr('id');
                        if (!row_id) return;

                        let field_id = row_id.replace('_field', '');
                        if (!invalid_field_ids.includes(field_id)) {
                            $row.removeClass('woocommerce-invalid woocommerce-invalid-email woocommerce-invalid-phone');
                            $row.siblings('.form-row__field-message--error').slideUp(200, function() { $(this).remove(); });
                        }
                    });

                    // 2. Add or update errors for fields that ARE invalid
                    Object.entries(invalid_fields).forEach(([field_id, errorText]) => {
                        let $field_row = getFieldRow(field_id);
                        if ($field_row && $field_row.length) {
                            $field_row.addClass('woocommerce-invalid');
                            has_inline_errors = true;

                            let $existingError = $field_row.siblings('.form-row__field-message--error');
                            if ($existingError.length === 0) {
                                let $errorSpan = $('<span class="form-row__field-message form-row__field-message--error" style="display: none;"></span>').text(errorText);
                                $field_row.after($errorSpan);
                                $errorSpan.slideDown(200);
                            } else {
                                // Stop any ongoing slideUp/Down and update text in place
                                $existingError.stop(true, true).text(errorText).show();
                            }
                        } else {
                            // Orphan / unattached error (e.g. field not in DOM or currently hidden)
                            orphan_errors.push(field_id + ': ' + errorText);
                        }
                    });
                } else {
                    // Clear all if there are no inline errors at all
                    $form.find('.form-row.woocommerce-invalid').removeClass('woocommerce-invalid woocommerce-invalid-email woocommerce-invalid-phone');
                    $form.find('.form-row__field-message--error').slideUp(200, function() { $(this).remove(); });
                }

                // 3. Render orphan errors into .general-notices if any exist
                let $target_notices = $(".notices.general-notices, .notices").first();
                if (orphan_errors.length > 0) {
                    if (!$target_notices.length) {
                        $target_notices = $('<ul class="notices general-notices"></ul>');
                        $form.before($target_notices);
                    }

                    let noticesHtml = '';
                    orphan_errors.forEach(msg => {
                        noticesHtml += `<li class="notice notice--error">${msg}</li>`;
                    });
                    $target_notices.html(noticesHtml).show();
                }

                // 4. Scroll to the first error: prioritize top notices if visible/populated, else first inline error
                let $scrollTo = null;
                if ($target_notices.length && $target_notices.children().length > 0 && $target_notices.is(':visible')) {
                    $scrollTo = $target_notices;
                } else if (has_inline_errors) {
                    $scrollTo = $form.find('.woocommerce-invalid:visible').first();
                }

                if ($scrollTo && $scrollTo.length) {
                    $("html, body").animate({
                        scrollTop: Math.max(0, $scrollTo.offset().top - 100)
                    }, 300);
                }
			}

		})

	}

	$(document).gp_ready(function(){
		$form.off("submit").submit(complete_order)
        
        // Clear inline error when user types
        $form.on("input change", ".woocommerce-invalid input, .woocommerce-invalid select, .woocommerce-invalid textarea", function() {
            let $row = $(this).closest('.form-row');
            $row.removeClass('woocommerce-invalid woocommerce-invalid-email woocommerce-invalid-phone');
            $row.siblings('.form-row__field-message--error').slideUp(200, function() { $(this).remove(); });
        });
        
        // DIČ dynamic description toggle
        let $dic_input = $('#billing_dic');
        if ($dic_input.length) {
            let $dic_desc = $dic_input.closest('.checkout_form__vat-number').find('.form-row__field-message--info');
            
            let toggleDicDesc = function() {
                if ($dic_input.val().trim() !== '') {
                    $dic_desc.slideUp(300);
                } else {
                    $dic_desc.slideDown(300);
                }
            };
            
            $dic_input.on('input change', toggleDicDesc);
            toggleDicDesc(); // initial run
        }
	})

    let user_exists = false

    // Show login prompt when an already registered address is filled in checkout and hide + uncheck the registration checkbox
    $('.checkout_form input[name="billing_email"]').on('change', function() {
        const email = $(this).val()

        gp_ajax({
            url: ghostpress_params.ajax_url,
            type: "post",
            dataType: "json",
            data: {
                email,
                action: "checkout_possible_login"
            },
        })
        .done((response) => {
            if (response.success && typeof response.data !== "undefined" && typeof response.data.user_exists !== "undefined"){
                // If the customer chooses to register and then inputs an already registered email address, they can't re-register with it, so update the cart and show them prices for unregistered customers, and if they remove it, allow showing prices for registered users again.
                // Only update the cart when this changes.
                if (response.data.user_exists){
                    $("div.terms_register").slideUp(250)
                    $('input[type=checkbox][name=register]').prop('disabled', true)

                    if (!user_exists && $form.find("input[name='register']").is(":checked")){
                        user_exists = true
                        update_cart()
                    }
                }
                else {
                    $("div.terms_register").slideDown(250)
                    $('input[type=checkbox][name=register]').prop('disabled', false)

                    if (user_exists && $form.find("input[name='register']").is(":checked")){
                        user_exists = false
                        update_cart()
                    }
                }
            }
        })
    })

})(jQuery);